import { AppstoreOutlined } from '@ant-design/icons'
import { Navigate } from 'react-router-dom'
import type { ProtectedRouteDescriptor } from '@/routes/types'
import { permissions } from '@/types/authorization'
import OrgListPage from '@/features/compliance/org-list'
import JobPage from '@/features/compliance/job'

export const complianceRouteDescriptors: ProtectedRouteDescriptor[] = [
  {
    key: 'annual-compliance',
    path: 'annual-compliance',
    element: <OrgListPage />,
    access: { anyOf: [permissions.viewAnnualCompliance] },
    nav: {
      sectionKey: 'compliance',
      label: 'CompVerify',
      Icon: AppstoreOutlined,
      order: 20,
    },
  },
  {
    key: 'annual-compliance-org-job',
    path: 'annual-compliance/org/:id/job/:jobId',
    element: <JobPage />,
    access: { anyOf: [permissions.viewAnnualCompliance] },
  },
  {
    key: 'compliance-root',
    path: 'compliance',
    element: <Navigate to="/annual-compliance" replace />,
    redirectTo: '/annual-compliance',
  },
]
